import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { UndoButton, CancelButton, ApplyButton, SaveButton } from '_components';
import styles from './Common.module.css';
import { AlTemplateDialog, AlWpTemplateDialog } from 'PatientCareCenter/Note/AL/Templates';


class AlTemplate extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            template: -1,
            customName: '',
            customTemplate: false,
            msg1Visible: false,
            msg2Visible: false
        };
    }

    handleChange(event) {
        // if event.target.value === any template name that has no user - msg2 true
        // else if event.target.value === any template name that has the user - msg1 true
        // else both false
        if (this.props.templates ? Object.keys(this.props.templates)
            .find(x => this.props.templates[x].XLTMPNAME === event.target.value && this.props.templates[x].XLTMPURNO === null) !== undefined ? true : false : false) {
            this.setState({
                customName: event.target.value,
                msg1Visible: false,
                msg2Visible: true
            });
        }
        else if (this.props.templates ? Object.keys(this.props.templates)
            .find(x => this.props.templates[x].XLTMPNAME === event.target.value && this.props.templates[x].XLTMPURNO !== null) !== undefined ? true : false : false) {
            this.setState({
                customName: event.target.value,
                msg1Visible: true,
                msg2Visible: false
            });
        } else {
            this.setState({
                customName: event.target.value,
                msg1Visible: false,
                msg2Visible: false
            });
        }
        this.setState({ customName: event.target.value });
    }

    handleTemplateChange(event) {
        let customTemplate = this.props.templates ? Object.keys(this.props.templates)
            .find(x => this.props.templates[x].XLTMPNO === parseInt(event.target.value) && this.props.templates[x].XLTMPURNO !== null) !== undefined ? true : false : false;

        // Clear existing template data when selecting a new template
        if (parseInt(event.target.value) !== -1) {
            this.props.cancelTemplate(this.props.noteId);
        }

        this.setState({
            template: event.target.value,
            customTemplate: customTemplate
        });
    }

    toggleSave() {
        if (this.props.savePanelVisible) {
            this.setState({ customName: '' });
        }
        this.props.toggleSaveAlTemplateVisible(this.props.noteId)
    }

    applyTemplate() {
        if (this.props.isWp) {
            this.props.getWpAlTemplate(parseInt(this.state.template), this.props.noteId, this.props.epno);
        } else {
            this.props.getAlTemplate(parseInt(this.state.template), this.props.noteId, this.props.epno);
        }

        this.setState({
            template: -1,
            customName: '',
            customTemplate: false,
            msg1Visible: false,
            msg2Visible: false
        });
    }

    deleteAlTemplate() {
        this.props.deleteAlTemplate(this.props.noteId, parseInt(this.state.template));
        this.setState({
            template: -1,
            customName: '',
            customTemplate: false,
            msg1Visible: false,
            msg2Visible: false
        });
    }

    undoDeleteAlTemplate() {
        this.props.undoDeleteAlTemplate(this.props.noteId, this.props.lastDeletedAlTemplate);
        this.setState({
            template: -1,
            customName: '',
            customTemplate: false,
            msg1Visible: false,
            msg2Visible: false
        });
    }

    saveAlTemplate() {
        this.props.saveAlTemplate(this.props.noteId, this.props.xlno, this.state.customName);
        this.setState({
            template: -1,
            customName: '',
            customTemplate: false,
            msg1Visible: false,
            msg2Visible: false
        });

    }


    render() {
        if (this.props.noteType === 2 && !this.props.isPeds && !this.props.isPedsSpeech) {
            return (
                <span />
            );
        } else {
            return (
                <span>
                    {this.props.templateVisible && !this.props.isWp &&
                        <AlTemplateDialog />
                    }
                    {this.props.templateVisible && this.props.isWp &&
                        <AlWpTemplateDialog />
                    }
                    {!this.props.chargesExist &&
                        <span className={styles.row}>
                            <span className={styles.template_label}>Template:</span>
                            <select className={styles.template_dropdown} value={this.state.template} onChange={event => this.handleTemplateChange(event)}>
                                <option key={-1} value={-1} disabled>Select a template...</option>

                                {Object.keys(this.props.templates)
                                    .map(id => {
                                        const template = this.props.templates[id];
                                        return (
                                            <option key={template.ID} value={template.XLTMPNO}>{template.XLTMPURNO ? '* ' + template.XLTMPNAME : template.XLTMPNAME}</option>
                                        );
                                    })
                                }
                            </select>

                            <span className={styles.template_button_wrapper}>
                                <ApplyButton title='Apply Template' size='extra-small' onClick={() => this.applyTemplate()} />
                            </span>
                            {this.props.saveButtonVisible && !this.props.savePanelVisible &&
                                <span className={styles.template_button_wrapper}>
                                    <SaveButton title='Save Template...' size='extra-small' onClick={() => this.toggleSave()} />
                                </span>
                            }
                            {this.props.savePanelVisible &&
                                <span className={styles.custom_template_wrapper}>
                                    <span className={styles.template_button_wrapper}>
                                        <input autoFocus name="customName" type="text" className={styles.custom_name} value={this.state.customName} onChange={event => this.handleChange(event)} />
                                    </span>
                                    {this.state.msg1Visible &&
                                        <span className={styles.template_button_wrapper}>
                                            <span className={styles.warning}>
                                                Replace existing template?
                                            </span>
                                        </span>
                                    }
                                    {this.state.msg2Visible &&
                                        <span className={styles.template_button_wrapper}>
                                            <span className={styles.warning}>
                                                Name exists as global template.
                                            </span>
                                        </span>
                                    }
                                    {!this.state.msg2Visible &&
                                        <span className={styles.template_button_wrapper}>
                                            <SaveButton title='Save' size='extra-small' onClick={() => this.saveAlTemplate()} />
                                        </span>
                                    }
                                    <span className={styles.template_button_wrapper}>
                                        <CancelButton title='Cancel' size='extra-small' onClick={() => this.toggleSave()} />
                                    </span>
                                </span>
                            }
                            {this.state.customTemplate && !this.props.savePanelVisible &&
                                <span className={styles.template_button_wrapper}>
                                    <CancelButton title='Delete Custom Template' size='extra-small' onClick={() => this.deleteAlTemplate()} />
                                </span>
                            }
                            {this.props.lastDeletedAlTemplate &&
                                <span className={styles.template_button_wrapper}>
                                    <UndoButton title='Undo Deletion of Custom Template' size='extra-small' onClick={() => this.undoDeleteAlTemplate()} />
                                </span>
                            }

                        </span>
                    }
                </span >
            );
        }
    }

}

function mapDispatchToProps(dispatch) {
    return {
        getWpAlTemplate: bindActionCreators(noteActions.getWpAlTemplate, dispatch),
        getAlTemplate: bindActionCreators(noteActions.getAlTemplate, dispatch),
        toggleSaveAlTemplateVisible: bindActionCreators(noteActions.toggleSaveAlTemplateVisible, dispatch),
        saveAlTemplate: bindActionCreators(noteActions.saveAlTemplate, dispatch),
        deleteAlTemplate: bindActionCreators(noteActions.deleteAlTemplate, dispatch),
        undoDeleteAlTemplate: bindActionCreators(noteActions.undoDeleteAlTemplate, dispatch),
        cancelTemplate: bindActionCreators(noteActions.cancelAlTemplate, dispatch),
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let templates = Object.keys(state.entities.notes.MLTEMPLATE)
        .filter(x => {
            return ((noteType === 1 && state.entities.notes.MLTEMPLATE[x].XLTMPEVNO === pk) ||
                (noteType !== 1 && state.entities.notes.MLTEMPLATE[x].XLTMPNTNO === pk));
        })
        .sort((a, b) => state.entities.notes.MLTEMPLATE[a].XLTMPORDER - state.entities.notes.MLTEMPLATE[b].XLTMPORDER)
        .map(key => state.entities.notes.MLTEMPLATE[key]);
    let templateVisible = state.ui.notes[noteId].alTemplateVisible;
    let savePanelVisible = state.ui.notes[noteId].savePanelVisible;
    let lastDeletedAlTemplate = state.ui.notes[noteId].lastDeletedAlTemplate;

    let isSpeechEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_SPEECH_ENABLED'].PRVALUE === 'true' : false;
    let isSpeech = state.entities.admissions[epno].discipline === "ST" && isSpeechEnabled;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled;
    let isPedsSpeech = state.entities.admissions[epno].isPeds && isPedsEnabled && isSpeechEnabled;

    // if count of all AL sections > 0 ? saveButtonVisible = true : false
    let saveButtonVisible =
        (Object.keys(state.entities.notes.MLAQUATICS).filter(x => { return (state.entities.notes.MLAQUATICS[x].XLAQXLNO === xlno) }).length) +
            (Object.keys(state.entities.notes.MLGAIT).filter(x => { return (state.entities.notes.MLGAIT[x].XLGAXLNO === xlno) }).length) +
            (Object.keys(state.entities.notes.MLMANUAL).filter(x => { return (state.entities.notes.MLMANUAL[x].XLMAXLNO === xlno) }).length) +
            (Object.keys(state.entities.notes.MLMODALITIES).filter(x => { return (state.entities.notes.MLMODALITIES[x].XLMDXLNO === xlno) }).length) +
            (Object.keys(state.entities.notes.MLNEURO).filter(x => { return (state.entities.notes.MLNEURO[x].XLNEXLNO === xlno) }).length) +
            (Object.keys(state.entities.notes.MLOTHER).filter(x => { return (state.entities.notes.MLOTHER[x].XLOEXLNO === xlno) }).length) +
            (Object.keys(state.entities.notes.MLSELFCARE).filter(x => { return (state.entities.notes.MLSELFCARE[x].XLSCXLNO === xlno) }).length) +
            (Object.keys(state.entities.notes.MLSPECIALTYTESTS).filter(x => { return (state.entities.notes.MLSPECIALTYTESTS[x].XLSZXLNO === xlno) }).length) +
            (Object.keys(state.entities.notes.MLTHERACT).filter(x => { return (state.entities.notes.MLTHERACT[x].XLTAXLNO === xlno) }).length) +
            (Object.keys(state.entities.notes.MLTHEREX).filter(x => { return (state.entities.notes.MLTHEREX[x].XLTEXLNO === xlno) }).length) +
            (Object.keys(state.entities.notes.MLWORKPROG).filter(x => { return (state.entities.notes.MLWORKPROG[x].XLWPXLNO === xlno) }).length)
            > 0 ? true : false;

    let isWp = state.entities.admissions[epno].isWP;

    let chargesExist = false;
    if (noteType === 1) {
        //do charges exist for eval?
        chargesExist = state.entities.notes.PTEVAL[pk].hasCharges ? true : false;
    }
    else {
        //do charges exist for something else
        chargesExist = state.entities.notes.PTNOTE[pk].hasCharges ? true : false;
    }


    return {
        noteId: noteId,
        noteType: noteType,
        epno: epno,
        xlno: xlno,
        templates: templates,
        templateVisible: templateVisible,
        savePanelVisible: savePanelVisible,
        saveButtonVisible: saveButtonVisible,
        lastDeletedAlTemplate: lastDeletedAlTemplate,
        isSpeech,
        isPeds,
        isWp,
        isPedsSpeech,
        chargesExist
    };
}

const connectedAlTemplate = connect(mapStateToProps, mapDispatchToProps)(AlTemplate);
export { connectedAlTemplate as AlTemplate };
